(function () {
  'use strict';

  // =========================
  // Helpers de carga en scope
  // =========================
  function swapImg(el) {
    if (!el || el.tagName !== 'IMG') return;

    var ds = el.getAttribute('data-src');
    if (ds) {
      el.src = ds;
      el.removeAttribute('data-src');
    }

    var dss = el.getAttribute('data-srcset');
    if (dss) {
      el.srcset = dss;
      el.removeAttribute('data-srcset');
    }

    el.classList.remove('huk_lazyload');
  }

  function preloadBg(el) {
    if (!el) return;
    var bg = el.style && el.style.backgroundImage;
    if (!bg || bg.indexOf('url(') === -1) return;

    var url = bg.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
    if (!url) return;

    var img = new Image();
    img.src = url;
  }

  function forceLoadInScope(scope) {
    if (!scope) return;

    // 1) IMG (lazy y “image swap” principal)
    var imgs = scope.querySelectorAll(
      'img.huk_lazyload[data-src], ' +
      'img.huk_lazyload[data-srcset], ' +
      'img.huk_swap_image[data-src], ' +
      'img.huk_swap_image[data-srcset]'
    );
    imgs.forEach(swapImg);

    // 2) Hover (DIV con background-image)
    var hovers = scope.querySelectorAll('.huk_menu_imgswap_after');
    hovers.forEach(preloadBg);
  }

  // Pequeño utilitario: resolver el drawer **en el momento**
  function getDrawer() {
    return document.querySelector('.mobile-navigation-drawer');
  }

  // Esperar a que aparezca el drawer en el DOM y luego ejecutar cb()
  function waitForDrawerThen(cb, timeoutMs) {
    var drawer = getDrawer();
    if (drawer) { cb(drawer); return; }

    var timedOut = false;
    var timer = null;
    if (timeoutMs) {
      timer = setTimeout(function () { timedOut = true; mo.disconnect(); }, timeoutMs);
    }

    var mo = new MutationObserver(function (muts) {
      if (timedOut) return;
      var found = getDrawer();
      if (found) {
        if (timer) clearTimeout(timer);
        mo.disconnect();
        cb(found);
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // Para enganchar listeners al drawer **una sola vez**
  function ensureDrawerHooks(drawer) {
    if (!drawer || drawer.__hukLazyHooksMounted) return;
    drawer.addEventListener('click', function () {
      // reintenta por acordeones internos
      setTimeout(function () { forceLoadInScope(drawer); }, 100);
    });
    drawer.__hukLazyHooksMounted = true;
  }

  // ======================================================
  // MÓVIL: carga forzada al abrir el drawer (Opción B)
  // ======================================================
  var BODY_OPEN_CLASS = 'reveal-mobile-nav';
  var toggle = document.querySelector('.mobile-nav-toggle');

  function openDrawerRoutine() {
    // Resolver drawer justo ahora; si no existe, esperar y luego cargar.
    var drawerNow = getDrawer();
    var run = function (d) {
      ensureDrawerHooks(d);
      // Pequeño delay por transición off-canvas
      setTimeout(function () { forceLoadInScope(d); }, 80);
    };
    if (drawerNow) run(drawerNow);
    else waitForDrawerThen(run, 1500); // espera hasta 1.5s a que el DOM lo inserte
  }

  // 1) Body class -> drawer abierto
  var moBody = new MutationObserver(function () {
    if (document.body.classList.contains(BODY_OPEN_CLASS)) {
      openDrawerRoutine();
    }
  });
  moBody.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // 2) Botón del drawer (por si la clase entra con delay)
  if (toggle) {
    toggle.addEventListener('click', function () {
      requestAnimationFrame(function () {
        if (document.body.classList.contains(BODY_OPEN_CLASS)) {
          openDrawerRoutine();
        }
      });
    });
  }

  // 3) Drawer ya abierto al cargar (caso raro)
  window.addEventListener('load', function () {
    if (document.body.classList.contains(BODY_OPEN_CLASS)) {
      openDrawerRoutine();
    }
  });

  // ======================================================
  // DESKTOP: hooks por item activo y por tab activo
  // ======================================================

  // Raíz del menú desktop (ajustado a tu DOM)
  var desktopMenuRoot =
    document.querySelector('#menu-liga') ||
    document.querySelector('.huk_menu_app_desktop') ||
    document.querySelector('.desktop-only .huk_menu_app') ||
    document.querySelector('.huk_menu_app');

  if (desktopMenuRoot) {
    // A) Pasada inicial: items/tab activos
    function loadActiveDesktopOnce() {
      desktopMenuRoot
        .querySelectorAll('li.huk_menu_item.huk_menu_item_has_child.huk_menu_item_active')
        .forEach(function (li) { forceLoadInScope(li); });

      desktopMenuRoot
        .querySelectorAll('.huk_menu_submenu_tab_item.huk_menu_submenu_tab_active')
        .forEach(function (tab) { forceLoadInScope(tab); });
    }
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(loadActiveDesktopOnce, 0);
    } else {
      document.addEventListener('DOMContentLoaded', loadActiveDesktopOnce);
    }

    // B) Cambios de clase en LIs con submenú (se abren por hover → ganan clase)
    var moLi = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') return;
        var li = mutation.target;
        if (!li.classList ||
            !li.classList.contains('huk_menu_item') ||
            !li.classList.contains('huk_menu_item_has_child')) return;

        if (li.classList.contains('huk_menu_item_active')) {
          forceLoadInScope(li);
          var panel = li.querySelector(
            '.huk_menu_submenu, ' +
            '.huk_menu_submenu_tab_content, ' +
            '.huk_menu_submenu_type_mega, ' +
            '.huk_menu_columns, ' +
            '.huk_menu_colwrapper'
          );
          if (panel) {
            forceLoadInScope(panel);
            setTimeout(function () { forceLoadInScope(panel); }, 100);
          }
        }
      });
    });

    desktopMenuRoot
      .querySelectorAll('li.huk_menu_item.huk_menu_item_has_child')
      .forEach(function (li) {
        moLi.observe(li, { attributes: true, attributeFilter: ['class'] });
      });

    // C) Cambios de tab activo
    var moTabs = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') return;
        var tab = mutation.target;
        if (!tab.classList || !tab.classList.contains('huk_menu_submenu_tab_item')) return;

        if (tab.classList.contains('huk_menu_submenu_tab_active')) {
          forceLoadInScope(tab);
          setTimeout(function () { forceLoadInScope(tab); }, 80);
        }
      });
    });

    desktopMenuRoot
      .querySelectorAll('.huk_menu_submenu_tab_item')
      .forEach(function (tab) {
        moTabs.observe(tab, { attributes: true, attributeFilter: ['class'] });
      });

    // D) Fallback por hover: si el skin no cambia clases visibles
    desktopMenuRoot.addEventListener('mouseenter', function (e) {
      var panel = e.target.closest &&
                  e.target.closest('.huk_menu_submenu, .huk_menu_submenu_tab_content');
      if (panel && desktopMenuRoot.contains(panel)) {
        forceLoadInScope(panel);
        setTimeout(function () { forceLoadInScope(panel); }, 60);
        return;
      }
      var li = e.target.closest &&
               e.target.closest('li.huk_menu_item.huk_menu_item_has_child');
      if (li && desktopMenuRoot.contains(li)) {
        forceLoadInScope(li);
      }
    }, true);

    // E) Si HUK inyecta estructura después, re-suscribe
    var moTree = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;

          if (node.matches && node.matches('li.huk_menu_item.huk_menu_item_has_child')) {
            moLi.observe(node, { attributes: true, attributeFilter: ['class'] });
            if (node.classList.contains('huk_menu_item_active')) forceLoadInScope(node);
          }
          node.querySelectorAll && node.querySelectorAll('li.huk_menu_item.huk_menu_item_has_child')
            .forEach(function (li2) {
              moLi.observe(li2, { attributes: true, attributeFilter: ['class'] });
              if (li2.classList.contains('huk_menu_item_active')) forceLoadInScope(li2);
            });

          if (node.matches && node.matches('.huk_menu_submenu_tab_item')) {
            moTabs.observe(node, { attributes: true, attributeFilter: ['class'] });
            if (node.classList.contains('huk_menu_submenu_tab_active')) forceLoadInScope(node);
          }
          node.querySelectorAll && node.querySelectorAll('.huk_menu_submenu_tab_item')
            .forEach(function (tab2) {
              moTabs.observe(tab2, { attributes: true, attributeFilter: ['class'] });
              if (tab2.classList.contains('huk_menu_submenu_tab_active')) forceLoadInScope(tab2);
            });
        });
      });
    });
    moTree.observe(desktopMenuRoot, { childList: true, subtree: true });
  }

})();